import axios from 'axios';

export interface AestheticsElement {
    color: string;
    background: string;
}

export interface AestheticsParams {
    primary: AestheticsElement;
    secondary?: AestheticsElement;
    terciary?: AestheticsElement;
}

export function saveAestheticsService(
    uuidInvestigation: string,
    aesthetics: AestheticsParams
): Promise<{ status: number }> {
    return new Promise((resolve, reject) => {
        axios
            .post(
                `${import.meta.env.VITE_APP_API_URL}/researcher/investigation/${uuidInvestigation}/aesthetics`,
                aesthetics,
                { headers: { Authorization: localStorage.getItem('jwt') } }
            )
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}
